import * as atomsComponents from './components/atoms';
import * as moleculesComponents from './components/molecules';
export * as atomTypes from './components/atoms/types';

export { default as ThemeProvider } from './theme/Provider';

/* Export whole structure */
export const atoms = atomsComponents;
export const molecules = moleculesComponents;

/* Exported atoms components */
export const Button = atoms.Button;
export const Input = atoms.Input;
export const Icon = atoms.Icon;
export const Heading = atoms.Heading;
export const Tabs = atoms.Tabs;
export const Text = atoms.Text;
export const Container = atoms.Container;
export const Checkbox = atoms.Checkbox;
export const Radio = atoms.Radio;
export const Column = atoms.Column;
export const Grid = atoms.Grid;
export const Droplist = atoms.Droplist;
export const TextArea = atoms.TextArea;
export const Tooltip = atoms.Tooltip;
export const Spinner = atoms.Spinner;
export const Logo = atoms.Logo;
export const AnimatedLogo = atoms.AnimatedLogo;

/* Exported molecules components */
export const Box = molecules.Box;
export const Select = molecules.Select;
export const Nav = molecules.Nav;
export const Menu = molecules.Menu;
export const Modal = molecules.Modal;
export const Table = molecules.Table;
